import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit } from "@angular/core";
import { FetchDataService } from "Services/fetch-data.service";
import { User } from "Classes/User";
declare var $: any;

@Component({
    selector: "admin-management",
    template: require('./admin-management.component.html'),
    styles: [require('./admin-management.component.css')]
})

export class AdminManagementComponent implements OnInit, AfterViewInit {
    constructor(
        private fetchDataService: FetchDataService
    ) { }

    @Input() userManagement: boolean;
    @Output() userManagementChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    createUser: string = "Create User";
    manageUsers: string = "Manage User Permissions";

    tabs: string[] = [
        this.createUser,
        this.manageUsers
    ];

    selectedTab: string = this.manageUsers;
    //headerText: string = "User Management";
    headerText: string = this.manageUsers;
    ngOnInit(): void {
    }

    ngAfterViewInit(): void {
        this.draggableSetup();
        $(window).resize(function (event, ui) {
            let container = $(".user-management-window-container");
            let elem = $(".user-management-window");
            let x = elem.width();
            let windowX = container.width();
            let y = elem.height();
            let windowY = container.height();
            let newLx = (windowX - x) / 2;
            let newLy = (windowY - y) / 2;
            if (newLx <= 0)
                newLx = 0;
            if (newLy <= 0)
                newLy = 0;
            elem.css("left", newLx + "px");
            elem.css("top", newLy + "px");
        });
    }

    draggableSetup(): void {
        $(".user-management-window").draggable({
            containment: "parent",
            cancel: `.user-management-body-container,
                .user-management-tabs-container, 
                .manage-users-container,
                .spinner-background,
                .edit-info-background-container,
                .cm-modal-window-background
                `,
            create: function (elem, ui) {
                let top = window.innerHeight / 2 - this.clientHeight / 2;
                let left = window.innerWidth / 2 - this.clientWidth / 2;
                if (top <= 0)
                    top = 0;
                if (left <= 0)
                    left = 0;
                $(this).css("top", top);
                $(this).css("left", left);
            },
            start: function (elem, ui) {
                let $this = $(this);
                let top = ui.position.top;
                let left = ui.position.left;
                if (top <= 0) {
                    ui.position.top = 0;
                    $this.css("top", 0);
                }
                if (left <= 0) {
                    ui.position.left = 0;
                    $this.css("left", 0);
                }
            },
            drag: function (elem, ui) {
                let $this = $(this);
                let top = ui.position.top;
                let left = ui.position.left;
                if (top <= 0) {
                    ui.position.top = 0;
                    $this.css("top", 0);
                }
                if (left <= 0) {
                    ui.position.left = 0;
                    $this.css("left", 0);
                }
            },
            stop: function (elem, ui) {
                let $this = $(this);
                let top = parseInt($this.css("top"));
                let left = parseInt($this.css("left"));
                if (top <= 0)
                    $this.css("top", "0px");
                if (left <= 0)
                    $this.css("left", "0px");
            }
        });
    }

    close(): void {
        this.userManagement = false;
        this.userManagementChange.emit(this.userManagement);
    }

    selectTab(tab: string): void {
        this.selectedTab = tab;
    }

    tabSelected(tab: string): string {
        if (this.selectedTab == tab)
            return "selected-tab";
        else
            return "";
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./App/Components/admin-management.component.ts